import styled from 'styled-components';

import { NotFoundCollections } from 'error/components/NotFoundCollections';
import { variableFontRegular } from 'styles/theme/text';
import { t } from 'localization/utils/t';

const TP = 'error.components.NotFound';

export const NotFound = ({ darkTheme }: { darkTheme?: boolean }) => (
  <NotFound.Wrapper>
    <NotFound.Header data-qa="not_found_message">
      {t(
        `${TP}.message`,
        "This page could not be found. Check out what's currently trending below.",
      )}
    </NotFound.Header>
    <NotFound.TrendingContainer>
      <NotFound.TrendingHeader data-qa="not_found_featured_collections">
        {t(`${TP}.featured`, 'Featured Collections')}
      </NotFound.TrendingHeader>
      <NotFound.SuggestionContainer>
        <NotFoundCollections darkTheme={darkTheme} />
      </NotFound.SuggestionContainer>
    </NotFound.TrendingContainer>
  </NotFound.Wrapper>
);

NotFound.Wrapper = styled.div`
  display: flex;
  min-height: calc(100vh - 216px);
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    margin-left: 169px;
  }
`;

NotFound.Header = styled.h1`
  font-weight: 600;
  text-align: left;
  margin: 0px 16px 72px;

  ${variableFontRegular({ size: '11.5px', height: '14px' })}
`;

NotFound.TrendingContainer = styled.div``;

NotFound.TrendingHeader = styled.h2`
  font-weight: 400;
  margin-left: 16px;
  margin-bottom: 20px;

  ${variableFontRegular({ size: '9.5px', height: '12px' })}
`;

NotFound.SuggestionContainer = styled.div`
  margin: 0 16px;
  max-width: 324px;
`;
